import React, {forwardRef, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Menu, MenuItem} from '@szhsin/react-menu';

import configuration from 'configuration';

const MenuButton = forwardRef<SVGSVGElement>(function MenuButton({...props}, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nav-button"
      viewBox="0 0 24 24"
      {...props}
      ref={ref}>
      <path
        className="icon"
        d="M5.8 1c.4 0 .7.3.7.8v1.8l1.7-.3c1.7-.4 3.4-.2 5 .4h.1a8 8 0 0 0 5 .4c.7-.2 1.4.4 1.4 1.2v7.4c0 .6-.4 1.2-1 1.3h-.2c-1.8.5-3.7.4-5.4-.3a8.7 8.7 0 0 0-4.9-.4l-1.7.3v8.2a.8.8 0 0 1-1.5 0v-20c0-.5.3-.8.8-.8Z"
      />
    </svg>
  );
});

const CountryItem = ({path}: {path: string}) => {
  const {t} = useTranslation();

  const code = t(configuration.path2langKey(path, 'code'));
  const name = t(configuration.path2langKey(path, 'name'));

  return (
    <>
      <span className={'fi fi-' + code.toLowerCase()}></span>
      &nbsp;&nbsp;
      <span>{name}</span>
    </>
  );
};

const CountriesMenu = ({
  path,
  selectCountry,
}: {
  path: string;
  selectCountry: (country: string) => void;
}) => {
  const {t} = useTranslation();

  const extraCountries = useMemo(
    () =>
      Object.keys(
        t(configuration.path2langKey(path, 'extraCountries'), {
          lng: 'de',
          returnObjects: true,
          defaultValue: {},
        }),
      ),
    [path, t],
  );

  return (
    <Menu onItemClick={e => selectCountry(e.value)} menuButton={<MenuButton />} transition>
      {extraCountries.map(country => {
        const iPath = path + 'extraCountries/' + country;
        return (
          <MenuItem key={iPath} value={country}>
            <CountryItem path={iPath} />
          </MenuItem>
        );
      })}
    </Menu>
  );
};
export default CountriesMenu;
